import styled, { css } from 'styled-components';

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  ${({ $gridColumn }) =>
    $gridColumn && css`
      grid-column: ${$gridColumn};
    `}
`;